export default function checkbox($rootScope) {
  'ngInject';

  return {
    restict: 'E',
    transclude: true,
    require: 'ngModel',
    template($scope, $attrs) {
      const isAlwaysPristine = 'alwaysPristine' in $attrs;

      return `
        <label class="checkmark" ng-disabled="isDisabled">
          <input type="checkbox" ${
            isAlwaysPristine ? 'always-pristine' : ''
          } ng-model="model" ng-disabled="isDisabled" />
          <span class="tick"></span>
          <span ng-transclude></span>
        </label>
      `;
    },
    scope: {
      isDisabled: '=?ngDisabled',
    },
    link($scope, $element, $attrs, $ngModelController) {
      $scope.$watch(
        () => $ngModelController.$viewValue,
        (value) => {
          $scope.model = value;
        }
      );

      $scope.$watch('model', (m) => {
        $ngModelController.$setViewValue(m);
        $scope.$$postDigest(() => {
          /**
           * This happens when ng-model is a getter/setter
           * and setter did not flip the value
           */
          if ($scope.model !== $ngModelController.$viewValue) {
            $scope.model = $ngModelController.$viewValue;
            if (!$rootScope.$$phase) {
              $rootScope.$digest();
            }
          }
        });
      });

      const tickElement = $element.find('span.tick');
      tickElement.on('mousedown', (e) => {
        if (e.target === tickElement[0] && $attrs.tickMousedownStopPropagation) {
          e.stopPropagation();
        }
      });
    },
  };
}
